import React, { Component } from "react";
import '../../Styles/SuperAdminTenantHome.scss'
import Images from "../../Assets/Images";
import SuperAdminTenantRemove from "../../Components/SuperAdmin/SuperAdminTenantRemove";
import SuperAdminTenantCreation from '../../Components/SuperAdmin/SuperAdminTenantCretion'
import { BrowserRouter as Router, Switch} from "react-router-dom";
import { renderRoutes } from 'react-router-config';
import {superAdminDashboardRoute} from '../../Routes/RoutesPath';
import {  Link,NavLink } from "react-router-dom";
import {history} from '../../Routes/history'
// import { createBrowserHistory } from "history";

// const history = createBrowserHistory()

class SuperAdminTenantHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addButton: false,
      removeButton: false
    }
  }

  render() {
    return (
      <div>
        <div className="rm-tanent-cont">
          <div className="rm-grids-cont">
            <div className="rm-col">
              <div className="rm-grid">
                <div className="rm-grid-icon">
                  <img src={Images.ADDUSER} width="40" alt="Add Tenant" />
                </div>
                <h5>Tenant Provision</h5>

                <Link to ='/superadmin/home/Add'>
                <button className="rm-btn-dark">New</button>
                </Link>
              </div>
              
            </div>
            <div className="rm-col">
              <div className="rm-grid">
                <div className="rm-grid-icon">
                  <img src={Images.REMOVEUSER} width="40" alt="Remove Tenant" />
                </div>
                <h5>Tenant Removal</h5>
                
                <Link to={'/superadmin/home/Remove'}>
                  <button className="rm-btn-dark">
                      View
                  </button>
                </Link>
                
              </div>
            </div>
          </div>
        </div>

        
        {renderRoutes(superAdminDashboardRoute)}
        
      </div>
    );
  }
}

export default SuperAdminTenantHome
